import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const CompanyPolicies: React.FC = () => {
  const { user } = useAuth();
  const viewer = encodeURIComponent(user?.email || 'pedram@lifeguardingacademy.com');

  return (
    <Container maxWidth={false} sx={{ mt: 3, mb: 3 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1, fontWeight: 600 }}>
          Company Policies
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Search policies, review related documents, and keep the internal knowledge index in sync with Google Drive.
        </Typography>
      </Paper>

      <Box
        component="iframe"
        title="Company Policies Knowledge System"
        src={`/api/company-policies/?viewer=${viewer}`}
        sx={{
          width: '100%',
          minHeight: 'calc(100vh - 220px)',
          border: 0,
          borderRadius: 3,
          backgroundColor: '#f7f8fb',
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
        }}
      />
    </Container>
  );
};

export default CompanyPolicies;
